"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GmEventService = void 0;
const anchor_1 = require("@project-serum/anchor");
const models_1 = require("../models");
const types_1 = require("../types");
const GmClientService_1 = require("./GmClientService");
const utils_1 = require("../utils");
const types_2 = require("../types");
/**
 * Listens to events emitted by the Galactic Marketplace program and will call the registered
 * onEvent() callback function for each event.
 *
 * @param connection Solana connection
 * @param programId The Galactic Marketplace program PublicKey
 * @param commitment Optional Solana commitment level, defaults the `connection` commitment level
 */
class GmEventService {
    constructor(connection, programId, commitment) {
        this.registeredCurrencyInfo = {};
        this.eventListeners = [];
        this.queuedEvents = [];
        this.connection = connection;
        this.programId = programId;
        this.commitment = commitment || connection.commitment;
        this.handleOrderCreated = this.handleOrderCreated.bind(this);
        this.handleOrderExchanged = this.handleOrderExchanged.bind(this);
        this.handleOrderCanceled = this.handleOrderCanceled.bind(this);
        this.setCurrencyInfo = this.setCurrencyInfo.bind(this);
        this.handleCurrencyRegistered = this.handleCurrencyRegistered.bind(this);
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.idl = (0, utils_1.getGmLogsIDL)(this.programId);
            this.provider = new anchor_1.AnchorProvider(this.connection, null, {
                commitment: this.commitment,
            });
            this.program = new anchor_1.Program(this.idl, this.programId, this.provider, {
                instruction: new anchor_1.BorshInstructionCoder(this.idl),
                accounts: new anchor_1.BorshAccountsCoder(this.idl),
                state: null,
                events: new anchor_1.BorshEventCoder(this.idl),
            });
            yield this.setCurrencyInfo();
            const createId = this.program.addEventListener(types_2.GmLogs.InitializeMemo, this.handleOrderCreated);
            const exchangeId = this.program.addEventListener(types_2.GmLogs.ExchangeMemo, this.handleOrderExchanged);
            const cancelId = this.program.addEventListener(types_2.GmLogs.CancelOrderMemo, this.handleOrderCanceled);
            const registerCurrencyId = this.program.addEventListener(types_2.GmLogs.RegisterCurrencyMemo, this.handleCurrencyRegistered);
            this.eventListeners.push(createId, exchangeId, cancelId, registerCurrencyId);
        });
    }
    end() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const listenerId of this.eventListeners) {
                yield this.program.removeEventListener(listenerId);
            }
            this.eventListeners = [];
            this.onEvent = null;
        });
    }
    setEventHandler(handler) {
        this.onEvent = handler;
        for (const event of this.queuedEvents) {
            this.onEvent(event.eventType, event.order, event.slotContext);
        }
    }
    setCurrencyInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const gmClientService = new GmClientService_1.GmClientService();
            const registeredCurrencyInfo = yield gmClientService.getRegisteredCurrencies(this.connection, this.programId, true);
            for (const info of registeredCurrencyInfo) {
                this.registeredCurrencyInfo[info.mint] = info;
            }
        });
    }
    getParsedOrderFromEvent(event, slotContext) {
        const currencyInfo = this.registeredCurrencyInfo[event.currencyMint.toString()];
        if (!currencyInfo)
            return null;
        const { decimals: currencyDecimals } = currencyInfo;
        return new models_1.Order({
            id: event.orderId.toString(),
            orderType: event.orderSide === 0 ? models_1.OrderSide.Buy : models_1.OrderSide.Sell,
            orderMint: event.assetMint.toString(),
            currencyMint: event.currencyMint.toString(),
            currencyDecimals,
            price: event.price,
            orderQtyRemaining: event.orderRemainingQty.toNumber(),
            orderOriginationQty: event.orderOriginationQty.toNumber(),
            owner: event.orderInitializerPubkey.toString(),
            ownerAssetTokenAccount: event.initializerAssetTokenAccount.toString(),
            ownerCurrencyTokenAccount: event.initializerCurrencyTokenAccount.toString(),
            createdAt: event.createdAtTimestamp.toNumber(),
            slotContext,
        });
    }
    handleOrderCreated(event, slotContext) {
        this.processEvent(types_1.GmEventType.orderAdded, this.getParsedOrderFromEvent(event, slotContext), slotContext);
    }
    handleOrderExchanged(event, slotContext) {
        this.processEvent(types_1.GmEventType.orderModified, this.getParsedOrderFromEvent(event, slotContext), slotContext);
    }
    handleOrderCanceled(event, slotContext) {
        this.processEvent(types_1.GmEventType.orderRemoved, this.getParsedOrderFromEvent(event, slotContext), slotContext);
    }
    /**
     * Add this code to centralize specific error handling
     * @param eventType
     * @param order
     * @param slotContext
     * @protected
     */
    processEvent(eventType, order, slotContext) {
        if (!this.onEvent) {
            this.queuedEvents.push({
                eventType,
                order,
                slotContext,
            });
            return;
        }
        this.onEvent(eventType, order, slotContext);
    }
    handleCurrencyRegistered() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setCurrencyInfo();
        });
    }
}
exports.GmEventService = GmEventService;
//# sourceMappingURL=GmEventService.js.map